import React, { PropTypes } from 'react';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import './RecentlyReturnedSummaryView.scss';
import { metadataIdFixer } from '@bibliocommons/utils-link';
import { FormattedMessage } from 'react-intl';
import { Chevron } from '@bibliocommons/base-icons';
import JacketCoverContainer from '../../../../containers/JacketCoverContainer';
import ImmutablePropTypes from 'react-immutable-proptypes';
import ItemList from '../../../shared/ItemList';
import { getIconForFormat } from '@bibliocommons/utils-format';
import { TextButton } from '@bibliocommons/base-buttons';


export default class RecentlyReturnedSummaryView extends BcReactComponent {

  static renderBibs(item) {
    if (!item.get('bib')) {
      return null;
    }
    const bib = item.get('bib');
    return (
      <div className="recently-returned-bib">
        <div className="jacketCoverDiv">
          <JacketCoverContainer src={bib.getIn(['briefInfo', 'jacket'])} format={bib.getIn(['briefInfo', 'format'])} alt="" />
        </div>
        <a className="hover-overlay" href={`/item/show/${metadataIdFixer(bib.get('id'))}`} title={bib.getIn(['briefInfo', 'title'])}>
          <span className="hover-overlay-inner">
            <span className={getIconForFormat(bib.getIn(['briefInfo', 'format']))} aria-hidden />
            <div className="title">
              {bib.getIn(['briefInfo', 'title'])}
            </div>
            { bib.getIn(['briefInfo', 'authors']).size ?
              <div className="author">
                <FormattedMessage id="by_authors" values={{ authorLinks: bib.getIn(['briefInfo', 'authors']).first() }} />
              </div>
              : null
            }
          </span>
        </a>
      </div>
    );
  }

  render() {
    const { switchViews, totalItems, itemsSinceLastCheckout } = this.props;

    return (
      <div>
        <div className="recently-returned-grid-view clearfix">
          <div className="col-xs-12 col-sm-7">
            <h3><FormattedMessage id="recently_returned" /></h3>
            <p><FormattedMessage id="recently_returned_description" /></p>
          </div>
          <ItemList className="cp-bcslider recently-returned-bibs col-xs-12">
            {itemsSinceLastCheckout.map(item => RecentlyReturnedSummaryView.renderBibs(item))}
          </ItemList>

          <div className="switch-views col-md-12">
            <TextButton handleClick={switchViews} className="history-link">
              <FormattedMessage id="recently_returned_show_all_history" values={{ total: totalItems }} />
              <Chevron.Right />
            </TextButton>
          </div>
        </div>
      </div>
    );
  }
}

RecentlyReturnedSummaryView.propTypes = {
  switchViews: PropTypes.func,
  totalItems: PropTypes.number,
  itemsSinceLastCheckout: ImmutablePropTypes.list
};



// WEBPACK FOOTER //
// ./app/components/borrowing/recentlyreturned/RecentlyReturnedSummaryView/RecentlyReturnedSummaryView.jsx